import { ReduxStateType } from '../../type-definitions';

export const getUserData = (store: ReduxStateType) => store.auth.userData;
export const getUserPermissionList = (store: ReduxStateType) =>
  store.shared.userPermissionList;
export const getUserRightList = (store: ReduxStateType) =>
  store.auth.userRightList;
export const getAuthError = (store: ReduxStateType) => store.auth.error;
